import axios from 'axios'
import {GetRoomDto, RoomAvailableDto, RoomModel} from '../features/room/models'
import {ResponseObject, ResponseObjectPaginated} from '../../../models'
import {ObjectIdModule} from '../features/modules/models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function createRoomService(dto: RoomModel) {
  return await axios.post<ResponseObject<RoomModel>>(`${BASEURL}/room/createRoom`, dto)
}

export async function deleteRoomService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<RoomModel>>(`${BASEURL}/room/deleteRoom`, {
    data: dto,
  })
}

export function getRoomsService(dto: GetRoomDto) {
  return axios.post<ResponseObjectPaginated<RoomModel[]>>(`${BASEURL}/room/getList`, dto)
}

export function getRoomsAvailableService(dto: RoomAvailableDto) {
  return axios.post<ResponseObjectPaginated<RoomModel[]>>(`${BASEURL}/room/getListAvailable`, dto)
}

export async function getRoomByIdService(id: string | undefined) {
  return await axios.get<ResponseObject<RoomModel>>(`${BASEURL}/room/getRoomById`, {
    params: {
      Id: id,
    },
  })
}

export async function editRoomService(dto: RoomModel) {
  return await axios.put<ResponseObject<RoomModel>>(`${BASEURL}/room/updateRoom`, dto)
}
